export const LANDING_PAGE_URL = 'https://magicdispatch.com';
